<template>
  <Layout header-class="header-left-align header-transparent" nav-alignment="left" :topbar-style="2"
    buy-button-class="btn-default btn-small">
    <PageBanner :image="require('@/assets/images/Newlandindpage/banner/about.webp')"
      :light-image="require('@/assets/images/Newlandindpage/banner/about-light.png')" :title="heroTitle"
      :lead="$t('About.hero_subtitle')" :current="$t('header.about')" />
    <div class="rwt-timeline-area rn-section-gap"
      :class="{ 'background-about-sec2': userLogin === true, '': userLogin === false }">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle class="LexenExtraBold" text-align="center" :subtitle="$t('About.working_process_subtitle')"
              :title="$t('About.working_process_title')" data-aos="fade-up" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt--50">
            <WorkingProcess :steps="timelineData" />
          </div>
        </div>
        <About />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import WorkingProcess from '../../components/elements/timeline/WorkingProcess'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import About from '../../components/elements/about/About'
import PageBanner from '../../components/common/PageBanner'

export default {
  name: 'Consulting',
  components: {
    Layout,
    SectionTitle,
    WorkingProcess,
    About,
    PageBanner
  },
  data() {
    return {}
  },
  computed: {
    // The locale copy carries <br /> breaks for the old left-aligned hero; the banner wraps itself
    heroTitle() {
      return this.$t('About.hero_title').replace(/<br\s*\/?>/g, '')
    },
    timelineData() {
      return [
        {
          id: '1',
          icon: 'search',
          title: this.$t('About.timeline_1_title'),
          description: this.$t('About.timeline_1_desc')
        },
        {
          id: '2',
          icon: 'layers',
          title: this.$t('About.timeline_2_title'),
          description: this.$t('About.timeline_2_desc')
        },
        {
          id: '3',
          icon: 'share-2',
          title: this.$t('About.timeline_3_title'),
          description: this.$t('About.timeline_3_desc')
        },
        {
          id: '4',
          icon: 'settings',
          title: this.$t('About.timeline_4_title'),
          description: this.$t('About.timeline_4_desc')
        }
      ]
    },
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>
<style>
.background-about-sec2 {
  background-image: url(../../assets/images/Newlandindpage/lightmode/bg-about-sec2.png);
  background-size: cover;
  background-position: -0% 0%;
  /* background-repeat: no-repeat; */
  background-position: center;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.background-about-sec1-dark {
  background-image: url(../../assets/images/Newlandindpage/newimage/Group-bg-sec1.png);
  background-size: cover;
  background-position: center;
  z-index: 2;
  width: 100%;
  height: 100%;
  filter: contrast(1.2);
}

.background-about-sec1 {
  background-image: url(../../assets/images/Newlandindpage/lightmode/bg-about-sec1.png);
  background-size: cover;
  background-position: -0% 0%;
  /* background-repeat: no-repeat; */
  background-position: center;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.fix-hg {
  height: 860px;
  display: flex;
  align-items: center;
}
</style>
